export interface Attachment {
    id: number;
    documentId: number;
    fileName: string;
    documentType: any;
    backOfficeApplicationId: number;
    createdAt: Date; 
    fileKey: string;
}

export enum DocumentType {
    AML_PASSPORT = 'AML_PASSPORT',
    ASSOCIATION_ARTICLES_BESPOKE_DOCUMENT = 'ASSOCIATION_ARTICLES_BESPOKE_DOCUMENT',
    ASSOCIATION_ARTICLES_BESPOKE_BY_LAWS_DOCUMENT = 'ASSOCIATION_ARTICLES_BESPOKE_BY_LAWS_DOCUMENT',
    AML_POLICIES = 'AML_POLICIES',
    AML_CV = 'AML_CV',
    AML_CERTIFICATES = 'AML_CERTIFICATES',
    RESOLUTION_OF_INCORPORATION = 'RESOLUTION_OF_INCORPORATION',
    SUPPORTING_DOCUMENT = 'SUPPORTING_DOCUMENT',
    INCORPORATION_CERTIFICATE_DOCUMENT = 'INCORPORATION_CERTIFICATE_DOCUMENT',
    WORLD_CHECK = 'WORLD_CHECK',
    MOST_RECENT_ACCOUNTS_DOCUMENT = 'MOST_RECENT_ACCOUNTS_DOCUMENT',
    CONSTITUTION_DOCUMENT = 'CONSTITUTION_DOCUMENT',
    GOOD_STANDING_CERTIFICATE_DOCUMENT = 'GOOD_STANDING_CERTIFICATE_DOCUMENT',
    SUPPORTING_DOCUMENTS_BY_REGULATOR = 'SUPPORTING_DOCUMENTS_BY_REGULATOR',
    APPLICATION_REPORT = 'APPLICATION_REPORT',
    PROOF_OF_PAYMENT = 'PROOF_OF_PAYMENT',
    RELEVANT_PERSON_CONFIRM_DOCUMENT = 'RELEVANT_PERSON_CONFIRM_DOCUMENT',
    KYC_REPORT = 'KYC_REPORT',
    KYC_IDENTITY_DOC = 'KYC_IDENTITY_DOC',
    
    APP_SUPPORTING_DOCUMENT = 'APP_SUPPORTING_DOCUMENT',
    IN_PRINCIPAL_APPROVAL_DOCUMENT = 'IN_PRINCIPAL_APPROVAL_DOCUMENT',
    PAYMENT_INVOICE = 'PAYMENT_INVOICE',
    CHANGES_AND_ADDITIONS = 'CHANGES_AND_ADDITIONS',
    STATEMENT_OF_COMPLIANCE = 'STATEMENT_OF_COMPLIANCE',
    LEASE_AGREEMENT = 'LEASE_AGREEMENT',
    POWER_OF_ATTORNEY_DOCUMENT = 'POWER_OF_ATTORNEY_DOCUMENT',
    REGISTRATION_CERTIFICATE_DOCUMENT = 'REGISTRATION_CERTIFICATE_DOCUMENT',
    LICENSE_DOCUMENT = 'LICENSE_DOCUMENT'
}


export const DOCUMENT_TYPE_MAP: Map<DocumentType, string> = new Map([
    [DocumentType.ASSOCIATION_ARTICLES_BESPOKE_DOCUMENT, 'Articles of Association'],
    [DocumentType.ASSOCIATION_ARTICLES_BESPOKE_BY_LAWS_DOCUMENT, 'Articles of Association'],
    [DocumentType.RESOLUTION_OF_INCORPORATION, 'Resolution of Incorporation'],
    [DocumentType.INCORPORATION_CERTIFICATE_DOCUMENT, 'Certificate of Incorporation'],
    [DocumentType.WORLD_CHECK, 'World-Check'],
    [DocumentType.MOST_RECENT_ACCOUNTS_DOCUMENT, 'Most Recent Accounts'],
    [DocumentType.CONSTITUTION_DOCUMENT, 'Constitution'],
    [DocumentType.GOOD_STANDING_CERTIFICATE_DOCUMENT, 'Good Standing Certificate'],
    [DocumentType.SUPPORTING_DOCUMENTS_BY_REGULATOR, 'Supporting Documents by Regulator'],
    [DocumentType.AML_PASSPORT, 'Passport'],
    [DocumentType.AML_POLICIES, 'AML Policies'],
    [DocumentType.AML_CV, 'CV'],
    [DocumentType.AML_CERTIFICATES, 'Certificates'],
    [DocumentType.SUPPORTING_DOCUMENT, 'Supporting Document'],
    [DocumentType.APPLICATION_REPORT, 'Application'],
    [DocumentType.PROOF_OF_PAYMENT, 'Receipt'],
    [DocumentType.RELEVANT_PERSON_CONFIRM_DOCUMENT, 'Relevant Person\'s Confirmation Document'],
    [DocumentType.KYC_REPORT, 'Kyc Report'],
    [DocumentType.KYC_IDENTITY_DOC, 'Kyc identity Document'],
    [DocumentType.APP_SUPPORTING_DOCUMENT, "Additional Information & Supporting Documents"],
    [DocumentType.IN_PRINCIPAL_APPROVAL_DOCUMENT, "In-Principle Approval"],
    [DocumentType.CHANGES_AND_ADDITIONS, 'Changes and Additions'],
    [DocumentType.STATEMENT_OF_COMPLIANCE, 'Statement of Compliance'],
    [DocumentType.LEASE_AGREEMENT, 'Lease Agreement'],
    [DocumentType.POWER_OF_ATTORNEY_DOCUMENT, 'Power of Attorney'],
    [DocumentType.REGISTRATION_CERTIFICATE_DOCUMENT, 'Certificate of Registration'],
    [DocumentType.LICENSE_DOCUMENT, 'License'],
]);

export interface AttachmentGroup {
  documentType: DocumentType;
  attachments: Attachment[];
}